export const API_BASE_URL = import.meta.env.VITE_EVENT_TEAM_API_BASE_URL
export const API_AUTH_BASE_URL = import.meta.env.VITE_AUTH_API_BASE_URL
export const API_REQUEST_TIMEOUT_MS = 10000
export const API_LIST_PAGE_SIZE = 15
